import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Check } from 'lucide-react';
import { SEO } from '../components/SEO';

const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper" data-testid="thankyou-page">
      <SEO
        title="Thank You"
        description="Thank you for contacting Legal Emphasis. Our team will reach out to you shortly."
      />
      <section className="bg-[#0A2A5E] py-20 md:py-32">
        <div className="le-container">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-20 h-20 bg-white/10 flex items-center justify-center mx-auto mb-8">
              <Check className="text-white" size={40} strokeWidth={2.5} />
            </div>
            <h1 className="le-heading-1 text-white mb-6">Thank You!</h1>
            <p className="text-xl text-gray-200 leading-relaxed">
              Your request has been submitted successfully. Our team will review your information and reach out to you within 24 hours.
            </p>
            {customerId && (
              <p className="text-gray-400 text-sm mt-6" data-testid="customer-ref">
                Reference ID: {customerId}
              </p>
            )}
          </div>
        </div>
      </section>

      <section className="le-section bg-white">
        <div className="le-container max-w-2xl text-center">
          <h2 className="le-heading-2 mb-6">What Happens Next?</h2>
          <div className="space-y-6 text-left">
            <div className="flex gap-4">
              <div className="w-8 h-8 bg-[#0A2A5E] flex-shrink-0 flex items-center justify-center text-white text-sm font-bold">1</div>
              <div>
                <h4 className="font-semibold text-[#0A2A5E] mb-1">Case Review</h4>
                <p className="text-gray-600 text-sm">Our team will review the details of your inquiry and assign the most appropriate attorney for your needs.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-8 h-8 bg-[#0A2A5E] flex-shrink-0 flex items-center justify-center text-white text-sm font-bold">2</div>
              <div>
                <h4 className="font-semibold text-[#0A2A5E] mb-1">Initial Contact</h4>
                <p className="text-gray-600 text-sm">An attorney or case coordinator will reach out to discuss your legal matter and answer any preliminary questions.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-8 h-8 bg-[#0A2A5E] flex-shrink-0 flex items-center justify-center text-white text-sm font-bold">3</div>
              <div>
                <h4 className="font-semibold text-[#0A2A5E] mb-1">Consultation</h4>
                <p className="text-gray-600 text-sm">We'll schedule a consultation to provide detailed guidance on your legal options and recommended next steps.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ThankYou;
